import { Button, CircularProgress } from '@mui/material';
import { Field } from 'formik';
import FormWrapper from 'src/components/FormWrapper';

const LoginForm = ({ onSubmit = () => {}, loaded, schema, initialValues, fields }) => {
  return (
    <>
      <FormWrapper onSubmit={onSubmit} initialValues={initialValues} validationSchema={schema}>
        {fields.map((field, index) => (
          <Field key={index} fullWidth {...field} sx={{ mb: '1rem' }} />
        ))}
        <Button
          type="submit"
          sx={{ mt: '1.5rem', width: '100%' }}
          variant="contained"
          disabled={!loaded}
          data-cy="loginButton"
        >
          {loaded ? 'Login' : 'Loading'}
          {!loaded && (
            <CircularProgress
              size={24}
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                mt: '-0.75rem',
                ml: '-0.75rem',
              }}
            />
          )}
        </Button>
      </FormWrapper>
    </>
  );
};

export default LoginForm;
